import { render, staticRenderFns } from "./BlockProductHero.vue?vue&type=template&id=c01e5188&scoped=true&"
import script from "./BlockProductHero.vue?vue&type=script&lang=ts&"
export * from "./BlockProductHero.vue?vue&type=script&lang=ts&"
import style0 from "./BlockProductHero.vue?vue&type=style&index=0&id=c01e5188&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01e5188",
  null
  
)

export default component.exports